import React from 'react';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { FORM_OPTIONAL_LABEL_ID } from '../../constants';

const FormOptionalLabel = (): React.JSX.Element => (
  <Text as="span" color="bodySecondary">
    <I18n k="forms.formHeader.formOptionalLabel.optional" />
  </Text>
);

FormOptionalLabel.id = FORM_OPTIONAL_LABEL_ID;
FormOptionalLabel.displayName = FORM_OPTIONAL_LABEL_ID;

export default FormOptionalLabel;
